export const PERMISSION_KEYS = {
  // ── Orders ────────────────────────────────────────────────────────────────
  OrdersRead: 'Orders.Read',
  OrdersWrite: 'Orders.Write',
  OrdersDelete: 'Orders.Delete',
  OrdersResolve: 'Orders.Resolve',

  // ── Invoices ──────────────────────────────────────────────────────────────
  InvoicesRead: 'Invoices.Read',
  InvoicesWrite: 'Invoices.Write',
  InvoicesDelete: 'Invoices.Delete',
  InvoicesSend: 'Invoices.Send',

  // ── Quotes ────────────────────────────────────────────────────────────────
  QuotesRead: 'Quotes.Read',
  QuotesWrite: 'Quotes.Write',
  QuotesDelete: 'Quotes.Delete',

  // ── CurrentAccounts ───────────────────────────────────────────────────────
  CurrentAccountsRead: 'CurrentAccounts.Read',
  CurrentAccountsWrite: 'CurrentAccounts.Write',
  CurrentAccountsDelete: 'CurrentAccounts.Delete',

  // ── Warehouse ─────────────────────────────────────────────────────────────
  WarehouseRead: 'Warehouse.Read',
  WarehouseWrite: 'Warehouse.Write',
  WarehouseDelete: 'Warehouse.Delete',

  // ── StockReceipts ─────────────────────────────────────────────────────────
  StockReceiptsRead: 'StockReceipts.Read',
  StockReceiptsWrite: 'StockReceipts.Write',

  // ── Products ──────────────────────────────────────────────────────────────
  ProductsRead: 'Products.Read',
  ProductsWrite: 'Products.Write',
  ProductsDelete: 'Products.Delete',

  // ── Categories ────────────────────────────────────────────────────────────
  CategoriesRead: 'Categories.Read',
  CategoriesWrite: 'Categories.Write',
  CategoriesDelete: 'Categories.Delete',

  // ── Brands ────────────────────────────────────────────────────────────────
  BrandsRead: 'Brands.Read',
  BrandsWrite: 'Brands.Write',
  BrandsDelete: 'Brands.Delete',

  // ── Attributes ────────────────────────────────────────────────────────────
  AttributesRead: 'Attributes.Read',
  AttributesWrite: 'Attributes.Write',
  AttributesDelete: 'Attributes.Delete',

  // ── Marketplace ───────────────────────────────────────────────────────────
  MarketplaceRead: 'Marketplace.Read',
  MarketplaceWrite: 'Marketplace.Write',
  MarketplaceSync: 'Marketplace.Sync',

  // ── EFatura ───────────────────────────────────────────────────────────────
  EFaturaRead: 'EFatura.Read',
  EFaturaWrite: 'EFatura.Write',
  EFaturaSend: 'EFatura.Send',

  // ── Billing ───────────────────────────────────────────────────────────────
  BillingRead: 'Billing.Read',
  BillingWrite: 'Billing.Write',

  // ── DeliveryNotes ─────────────────────────────────────────────────────────
  DeliveryNotesRead: 'DeliveryNotes.Read',
  DeliveryNotesWrite: 'DeliveryNotes.Write',
  DeliveryNotesDelete: 'DeliveryNotes.Delete',

  // ── CheckNotes ────────────────────────────────────────────────────────────
  CheckNotesRead: 'CheckNotes.Read',
  CheckNotesWrite: 'CheckNotes.Write',

  // ── CashBank ──────────────────────────────────────────────────────────────
  CashBankRead: 'CashBank.Read',
  CashBankWrite: 'CashBank.Write',
  CashBankDelete: 'CashBank.Delete',

  // ── Expenses ──────────────────────────────────────────────────────────────
  ExpensesRead: 'Expenses.Read',
  ExpensesWrite: 'Expenses.Write',
  ExpensesDelete: 'Expenses.Delete',

  // ── PrintTemplates ────────────────────────────────────────────
  PrintTemplatesRead: 'PrintTemplates.Read',
  PrintTemplatesWrite: 'PrintTemplates.Write',
  PrintTemplatesDelete: 'PrintTemplates.Delete',

  // ── Reports ───────────────────────────────────────────────────────────────
  ReportsRead: 'Reports.Read',
  ReportsWrite: 'Reports.Write',

  // ── Jobs ──────────────────────────────────────────────────────────────────
  JobsRead: 'Jobs.Read',
  JobsWrite: 'Jobs.Write',

  // ── Settings ──────────────────────────────────────────────────────────────
  SettingsLocalizationRead: 'Settings.Localization.Read',
  SettingsLocalizationWrite: 'Settings.Localization.Write',
  SettingsOperationsDefaultsRead: 'Settings.OperationsDefaults.Read',
  SettingsOperationsDefaultsWrite: 'Settings.OperationsDefaults.Write',
  SettingsFxRead: 'Settings.Fx.Read',
  SettingsFxWrite: 'Settings.Fx.Write',
  SettingsCompanyRead: 'Settings.Company.Read',
  SettingsCompanyWrite: 'Settings.Company.Write',
  SettingsDocumentNumberingRead: 'Settings.DocumentNumbering.Read',
  SettingsDocumentNumberingWrite: 'Settings.DocumentNumbering.Write',
  SettingsIntegrationsMarketplacesRead: 'Settings.Integrations.Marketplaces.Read',
  SettingsIntegrationsMarketplacesWrite: 'Settings.Integrations.Marketplaces.Write',
  SettingsIntegrationsEfaturaRead: 'Settings.Integrations.Efatura.Read',
  SettingsIntegrationsEfaturaWrite: 'Settings.Integrations.Efatura.Write',
  SettingsSecurityUsersRead: 'Settings.Security.Users.Read',
  SettingsSecurityUsersWrite: 'Settings.Security.Users.Write',
  SettingsSecurityAuditLogsRead: 'Settings.Security.AuditLogs.Read',
  SettingsSecurityPermissionsRead: 'Settings.Security.Permissions.Read',
  SettingsSecurityPermissionsWrite: 'Settings.Security.Permissions.Write',
  SettingsAppsRead: 'Settings.Apps.Read',
  SettingsAppsWrite: 'Settings.Apps.Write',
  SettingsEmailRead: 'Settings.Email.Read',
  SettingsEmailWrite: 'Settings.Email.Write',
} as const;

export type PermissionKey = typeof PERMISSION_KEYS[keyof typeof PERMISSION_KEYS];

export const PERMISSION_KEYS_LIST: PermissionKey[] = Object.values(PERMISSION_KEYS);

/** Groups for matrix UI — each group has a label key and a list of permission keys in Read/Write order. */
export const PERMISSION_GROUPS = [
  {
    labelKey: 'settings.security.permissions.column.general',
    keys: [
      PERMISSION_KEYS.SettingsLocalizationRead,
      PERMISSION_KEYS.SettingsLocalizationWrite,
      PERMISSION_KEYS.SettingsOperationsDefaultsRead,
      PERMISSION_KEYS.SettingsOperationsDefaultsWrite,
      PERMISSION_KEYS.SettingsFxRead,
      PERMISSION_KEYS.SettingsFxWrite,
      PERMISSION_KEYS.SettingsEmailRead,
      PERMISSION_KEYS.SettingsEmailWrite,
      PERMISSION_KEYS.SettingsCompanyRead,
      PERMISSION_KEYS.SettingsCompanyWrite,
      PERMISSION_KEYS.SettingsDocumentNumberingRead,
      PERMISSION_KEYS.SettingsDocumentNumberingWrite,
    ],
  },
  {
    labelKey: 'settings.security.permissions.column.integrations',
    keys: [
      PERMISSION_KEYS.SettingsIntegrationsMarketplacesRead,
      PERMISSION_KEYS.SettingsIntegrationsMarketplacesWrite,
      PERMISSION_KEYS.SettingsIntegrationsEfaturaRead,
      PERMISSION_KEYS.SettingsIntegrationsEfaturaWrite,
    ],
  },
  {
    labelKey: 'settings.security.permissions.column.security',
    keys: [
      PERMISSION_KEYS.SettingsSecurityUsersRead,
      PERMISSION_KEYS.SettingsSecurityUsersWrite,
      PERMISSION_KEYS.SettingsSecurityAuditLogsRead,
      PERMISSION_KEYS.SettingsSecurityPermissionsRead,
      PERMISSION_KEYS.SettingsSecurityPermissionsWrite,
    ],
  },
  {
    labelKey: 'settings.security.permissions.column.apps',
    keys: [
      PERMISSION_KEYS.SettingsAppsRead,
      PERMISSION_KEYS.SettingsAppsWrite,
    ],
  },
] as const;

/**
 * Resource-oriented grouping for master-detail UI.
 * Each resource is one row with Read + Write columns; auditLogs has no Write side.
 *
 * MATRIX DISPLAY NOTE (AB#1011 Read-default model):
 * Every TenantMember automatically holds all *.Read keys as a baseline — no DB row needed.
 * The matrix should show Read as "granted" even when GET /permissions returns the effective
 * set (which includes Read by default). Write/Delete/special verb keys require an explicit grant.
 * The react-frontend pass must query the effective set from the API, not raw DB grant rows.
 */
export interface PermissionResource {
  labelKey: string;
  readKey: PermissionKey;
  writeKey?: PermissionKey;
  deleteKey?: PermissionKey;
  specialKeys?: { key: PermissionKey; labelKey: string }[];
}

export interface PermissionResourceGroup {
  labelKey: string;
  resources: PermissionResource[];
}

export const PERMISSION_RESOURCE_GROUPS: readonly PermissionResourceGroup[] = [
  {
    labelKey: 'settings.security.permissions.column.orders',
    resources: [
      {
        labelKey: 'settings.security.permissions.resource.orders',
        readKey: PERMISSION_KEYS.OrdersRead,
        writeKey: PERMISSION_KEYS.OrdersWrite,
        deleteKey: PERMISSION_KEYS.OrdersDelete,
        specialKeys: [
          { key: PERMISSION_KEYS.OrdersResolve, labelKey: 'settings.security.permissions.action.resolveShort' },
        ],
      },
      {
        labelKey: 'settings.security.permissions.resource.invoices',
        readKey: PERMISSION_KEYS.InvoicesRead,
        writeKey: PERMISSION_KEYS.InvoicesWrite,
        deleteKey: PERMISSION_KEYS.InvoicesDelete,
        specialKeys: [
          { key: PERMISSION_KEYS.InvoicesSend, labelKey: 'settings.security.permissions.action.sendShort' },
        ],
      },
      {
        labelKey: 'settings.security.permissions.resource.quotes',
        readKey: PERMISSION_KEYS.QuotesRead,
        writeKey: PERMISSION_KEYS.QuotesWrite,
        deleteKey: PERMISSION_KEYS.QuotesDelete,
      },
      {
        labelKey: 'settings.security.permissions.resource.deliveryNotes',
        readKey: PERMISSION_KEYS.DeliveryNotesRead,
        writeKey: PERMISSION_KEYS.DeliveryNotesWrite,
        deleteKey: PERMISSION_KEYS.DeliveryNotesDelete,
      },
      {
        labelKey: 'settings.security.permissions.resource.printTemplates',
        readKey: PERMISSION_KEYS.PrintTemplatesRead,
        writeKey: PERMISSION_KEYS.PrintTemplatesWrite,
        deleteKey: PERMISSION_KEYS.PrintTemplatesDelete,
      },
    ],
  },
  {
    labelKey: 'settings.security.permissions.column.catalog',
    resources: [
      {
        labelKey: 'settings.security.permissions.resource.products',
        readKey: PERMISSION_KEYS.ProductsRead,
        writeKey: PERMISSION_KEYS.ProductsWrite,
        deleteKey: PERMISSION_KEYS.ProductsDelete,
      },
      {
        labelKey: 'settings.security.permissions.resource.categories',
        readKey: PERMISSION_KEYS.CategoriesRead,
        writeKey: PERMISSION_KEYS.CategoriesWrite,
        deleteKey: PERMISSION_KEYS.CategoriesDelete,
      },
      {
        labelKey: 'settings.security.permissions.resource.brands',
        readKey: PERMISSION_KEYS.BrandsRead,
        writeKey: PERMISSION_KEYS.BrandsWrite,
        deleteKey: PERMISSION_KEYS.BrandsDelete,
      },
      {
        labelKey: 'settings.security.permissions.resource.attributes',
        readKey: PERMISSION_KEYS.AttributesRead,
        writeKey: PERMISSION_KEYS.AttributesWrite,
        deleteKey: PERMISSION_KEYS.AttributesDelete,
      },
    ],
  },
  {
    labelKey: 'settings.security.permissions.column.inventory',
    resources: [
      {
        labelKey: 'settings.security.permissions.resource.warehouse',
        readKey: PERMISSION_KEYS.WarehouseRead,
        writeKey: PERMISSION_KEYS.WarehouseWrite,
        deleteKey: PERMISSION_KEYS.WarehouseDelete,
      },
      {
        labelKey: 'settings.security.permissions.resource.stockReceipts',
        readKey: PERMISSION_KEYS.StockReceiptsRead,
        writeKey: PERMISSION_KEYS.StockReceiptsWrite,
      },
    ],
  },
  {
    labelKey: 'settings.security.permissions.column.finance',
    resources: [
      {
        labelKey: 'settings.security.permissions.resource.currentAccounts',
        readKey: PERMISSION_KEYS.CurrentAccountsRead,
        writeKey: PERMISSION_KEYS.CurrentAccountsWrite,
        deleteKey: PERMISSION_KEYS.CurrentAccountsDelete,
      },
      {
        labelKey: 'settings.security.permissions.resource.cashBank',
        readKey: PERMISSION_KEYS.CashBankRead,
        writeKey: PERMISSION_KEYS.CashBankWrite,
        deleteKey: PERMISSION_KEYS.CashBankDelete,
      },
      {
        labelKey: 'settings.security.permissions.resource.checkNotes',
        readKey: PERMISSION_KEYS.CheckNotesRead,
        writeKey: PERMISSION_KEYS.CheckNotesWrite,
      },
      {
        labelKey: 'settings.security.permissions.resource.expenses',
        readKey: PERMISSION_KEYS.ExpensesRead,
        writeKey: PERMISSION_KEYS.ExpensesWrite,
        deleteKey: PERMISSION_KEYS.ExpensesDelete,
      },
    ],
  },
  {
    labelKey: 'settings.security.permissions.column.marketplace',
    resources: [
      {
        labelKey: 'settings.security.permissions.resource.marketplace',
        readKey: PERMISSION_KEYS.MarketplaceRead,
        writeKey: PERMISSION_KEYS.MarketplaceWrite,
        specialKeys: [
          { key: PERMISSION_KEYS.MarketplaceSync, labelKey: 'settings.security.permissions.action.syncShort' },
        ],
      },
      {
        labelKey: 'settings.security.permissions.resource.efatura',
        readKey: PERMISSION_KEYS.EFaturaRead,
        writeKey: PERMISSION_KEYS.EFaturaWrite,
        specialKeys: [
          { key: PERMISSION_KEYS.EFaturaSend, labelKey: 'settings.security.permissions.action.sendShort' },
        ],
      },
    ],
  },
  {
    labelKey: 'settings.security.permissions.column.reporting',
    resources: [
      {
        labelKey: 'settings.security.permissions.resource.reports',
        readKey: PERMISSION_KEYS.ReportsRead,
        writeKey: PERMISSION_KEYS.ReportsWrite,
      },
      {
        labelKey: 'settings.security.permissions.resource.jobs',
        readKey: PERMISSION_KEYS.JobsRead,
        writeKey: PERMISSION_KEYS.JobsWrite,
      },
    ],
  },
  {
    labelKey: 'settings.security.permissions.column.general',
    resources: [
      {
        labelKey: 'settings.security.permissions.resource.localization',
        readKey: PERMISSION_KEYS.SettingsLocalizationRead,
        writeKey: PERMISSION_KEYS.SettingsLocalizationWrite,
      },
      {
        labelKey: 'settings.security.permissions.resource.operationsDefaults',
        readKey: PERMISSION_KEYS.SettingsOperationsDefaultsRead,
        writeKey: PERMISSION_KEYS.SettingsOperationsDefaultsWrite,
      },
      {
        labelKey: 'settings.security.permissions.resource.fx',
        readKey: PERMISSION_KEYS.SettingsFxRead,
        writeKey: PERMISSION_KEYS.SettingsFxWrite,
      },
      {
        labelKey: 'settings.security.permissions.resource.email',
        readKey: PERMISSION_KEYS.SettingsEmailRead,
        writeKey: PERMISSION_KEYS.SettingsEmailWrite,
      },
      {
        labelKey: 'settings.security.permissions.resource.companies',
        readKey: PERMISSION_KEYS.SettingsCompanyRead,
        writeKey: PERMISSION_KEYS.SettingsCompanyWrite,
      },
      {
        labelKey: 'settings.security.permissions.resource.documentNumbering',
        readKey: PERMISSION_KEYS.SettingsDocumentNumberingRead,
        writeKey: PERMISSION_KEYS.SettingsDocumentNumberingWrite,
      },
    ],
  },
  {
    labelKey: 'settings.security.permissions.column.integrations',
    resources: [
      {
        labelKey: 'settings.security.permissions.resource.marketplaces',
        readKey: PERMISSION_KEYS.SettingsIntegrationsMarketplacesRead,
        writeKey: PERMISSION_KEYS.SettingsIntegrationsMarketplacesWrite,
      },
      {
        labelKey: 'settings.security.permissions.resource.efaturaSettings',
        readKey: PERMISSION_KEYS.SettingsIntegrationsEfaturaRead,
        writeKey: PERMISSION_KEYS.SettingsIntegrationsEfaturaWrite,
      },
    ],
  },
  {
    labelKey: 'settings.security.permissions.column.security',
    resources: [
      {
        labelKey: 'settings.security.permissions.resource.users',
        readKey: PERMISSION_KEYS.SettingsSecurityUsersRead,
        writeKey: PERMISSION_KEYS.SettingsSecurityUsersWrite,
      },
      {
        labelKey: 'settings.security.permissions.resource.auditLogs',
        readKey: PERMISSION_KEYS.SettingsSecurityAuditLogsRead,
      },
      {
        labelKey: 'settings.security.permissions.resource.permissions',
        readKey: PERMISSION_KEYS.SettingsSecurityPermissionsRead,
        writeKey: PERMISSION_KEYS.SettingsSecurityPermissionsWrite,
      },
    ],
  },
  {
    labelKey: 'settings.security.permissions.column.apps',
    resources: [
      {
        labelKey: 'settings.security.permissions.resource.apps',
        readKey: PERMISSION_KEYS.SettingsAppsRead,
        writeKey: PERMISSION_KEYS.SettingsAppsWrite,
      },
    ],
  },
];
